// Text step fields. Answer cap: 2000 server-side (answers.rs), 200 on the
// widget's single line.

import { Input, SegmentedControl, Textarea } from "@pej/kore/components";
import type { Control } from "react-hook-form";
import { Field } from "@/lib/forms";
import { StepDescriptionField } from "./step-description-field";
import type { StepsFormValues } from "./survey-schema";

export interface TextStepFieldsProps {
    control: Control<StepsFormValues>;
    stepIndex: number;
}

export function TextStepFields({ control, stepIndex }: TextStepFieldsProps) {
    return (
        <div className="flex flex-col gap-4">
            <Field
                name={`steps.${stepIndex}.prompt`}
                control={control}
                label="Prompt"
                required
                render={({ field }) => <Input {...field} placeholder="Anything else?" />}
            />
            <StepDescriptionField control={control} name={`steps.${stepIndex}.description`} />
            <Field
                name={`steps.${stepIndex}.multiline`}
                control={control}
                label="Answer"
                description="A single line suits short answers, such as a name."
                render={({ field: { value, onChange } }) => (
                    <SegmentedControl<"multi" | "single">
                        aria-label="Answer"
                        value={value ? "multi" : "single"}
                        onValueChange={(next) => onChange(next === "multi")}
                        options={[
                            { value: "multi", label: "Text box" },
                            { value: "single", label: "Single line" },
                        ]}
                    />
                )}
            />
            <Field
                name={`steps.${stepIndex}.placeholder`}
                control={control}
                label="Placeholder"
                optional
                render={({ field }) => <Textarea {...field} placeholder="Tell us more…" aria-label="Placeholder" />}
            />
        </div>
    );
}
